import React from 'react'

import Layout from 'components/shared/Layout'

import WebOrders from './WebOrders'
import Estates from './Estates'

const MyEstates = () => {
  return (
    <Layout documentTitle="Oppdrag">
      <WebOrders />
      <Estates />
    </Layout>
  )
}

export default MyEstates
